module.exports = __webpack_public_path__ + "media/Video05_assertive.97e70459.mp4";